<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">产业基础信息</div>
        </zj-layout-header>
      </zj-layout-container>

      <el-form-item
        label="组织机构"
        prop="OrgId"
        style="display: inline-block"
      >
        <el-select
          v-model="ruleForm.OrgId"
          placeholder="请选择"
          style="width: 50rem"
          @change="chooseOrg"
          v-bind:disabled="!IsEditOrg"
        >
          <el-option
            v-for="item in optionsOrgId"
            :key="item.OrgId"
            :label="item.OrgName"
            :value="item.OrgId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="企业名称"
        prop="Name"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.Name"
          type="text"
          step="1"
          min="0"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写企业名称"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="男坑位数"
        prop="Man"
        style="display: inline-block"
        v-if="Status == 13"
      >
        <el-input
          v-model="ruleForm.Man"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写男坑位数量"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="女坑位数"
        prop="Women"
        style="display: inline-block"
        v-if="Status == 13"
      >
        <el-input
          v-model="ruleForm.Women"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写女坑位数量"
        ></el-input>
      </el-form-item>

      <!-- <el-form-item
        label="企业类型"
        prop="CompanyType"
        style="display: inline-block"
      >
        <el-select
          v-model="ruleForm.CompanyType"
          placeholder="请选择"
          style="width: 50rem"
        >
          <el-option>请选择</el-option>
          <el-option
            v-for="item in optionsType"
            :key="item.ItemKey"
            :label="item.Extend1"
            :value="item.ItemKey"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item
        label="企业简称"
        prop="LoginName"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.LoginName"
          type="text"
          step="1"
          min="0"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写企业简称"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="房间数"
        prop="Number"
        style="display: inline-block"
        v-if="Status == 3 || Status == 4"
      >
        <el-input
          v-model="ruleForm.Number"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写房间数"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="联系人"
        prop="AdminName"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.AdminName"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写联系人"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="联系电话"
        prop="AdminPhone"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.AdminPhone"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写联系电话"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="经度"
        prop="Longitude"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.Longitude"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写经度"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="纬度"
        prop="Latitude"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.Latitude"
          style="width: 45rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写纬度"
        ></el-input>
      </el-form-item>

      <ZjLngLatSelect
        class="newtaskposition"
        :point_lat="ruleForm.Latitude"
        :point_lng="ruleForm.Longitude"
        @onGotLngLat="onGotLngLat"
      ></ZjLngLatSelect>
      <el-form-item
        label="责任单位"
        prop="ManagementUnit"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.ManagementUnit"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写责任单位"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="所属区域"
        prop="BelongArea"
        style="display: inline-block"
      >
        <el-select
          v-model="ruleForm.BelongArea"
          placeholder="请选择"
          style="width: 50rem"
          :disabled="!IsEdit"
        >
          <el-option>请选择</el-option>
          <el-option
            v-for="item in EqRegionArr"
            :key="item.RegionId"
            :label="item.RegionName"
            :value="item.RegionId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="等级"
        prop="Level"
        style="display: inline-block"
        v-if="Status == 1 || Status == 4 || Status == 5"
      >
        <el-select
          v-model="ruleForm.Level"
          placeholder="请选择"
          style="width: 50rem"
          :disabled="!IsEdit"
        >
          <el-option>请选择</el-option>
          <el-option
            v-for="item in optionsLevel"
            :key="item.ItemKey"
            :label="item.Extend1"
            :value="item.ItemKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="企业地址"
        prop="Address"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.Address"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写企业地址"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="企业简介"
        prop="Introduction"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.Introduction"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请填写企业简介"
        ></el-input>
      </el-form-item>
      <el-form-item label="企业图片">
        <el-upload
          action="#"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :http-request="uploadAvatar"
          :before-upload="beforeAvatarUpload"
          :file-list="fileList"
          :disabled="!IsEdit"
        >
          <i class="addIcon"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img
            width="100%"
            :src="dialogImageUrl"
            alt=""
          />
        </el-dialog>
      </el-form-item>
      <el-form-item
        class="right"
        style="width: 134rem"
      >
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :disabled="!IsEdit"
          v-if="IsEdit"
        >提交</el-button>
        <!--      <el-button @click="resetForm('')" :disabled="!IsEdit" v-if="IsEdit">重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
import ZJApp from "../../../../../app";
import waitAll from "../../../../../../utils/src/waitAll";
import areaApi from "../../../../../broadcast/src/apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "CompanyAdd",
  controller: "UI",
  action: "CompanyAdd",
  data() {
    return {
      optionsOrgId: [],
      optionsType: [
        { ItemKey: 1, Extend1: "饭店" },
        { ItemKey: 2, Extend1: "旅行社" },
        { ItemKey: 3, Extend1: "景区" },
        { ItemKey: 4, Extend1: "酒店" },
        { ItemKey: 5, Extend1: "购物场所" },
        { ItemKey: 6, Extend1: "娱乐场所" },
      ],
      optionsLevel: [
        { ItemKey: "3A", Extend1: "3A" },
        { ItemKey: "4A", Extend1: "4A" },
        { ItemKey: "5A", Extend1: "5A" },
        { ItemKey: "其他", Extend1: "其他" },
      ],
      optionsScenic: [
        //景区
        { ItemKey: "3A", Extend1: "3A" },
        { ItemKey: "4A", Extend1: "4A" },
        { ItemKey: "5A", Extend1: "5A" },
        { ItemKey: "其他", Extend1: "其他" },
      ],
      optionsHotel: [
        //酒店 饭店
        { ItemKey: "3星", Extend1: "3星" },
        { ItemKey: "4星", Extend1: "4星" },
        { ItemKey: "5星", Extend1: "5星" },
        { ItemKey: "其他", Extend1: "其他" },
      ],
      EqRegionArr: [],
      ruleForm: {
        JsonExtend: {
          ScenicName: "",
          ScenicId: "",
          TotalPlace: "",
          FileId: "",
        },
        // ID: '',
        Latitude: "",
        Longitude: "",
      },
      rules: {
        Name: [{ required: true, message: "请填写企业名称", trigger: "blur" }],
        // CompanyType: [
        //   { required: true, message: "请选择企业类型", trigger: "blur" },
        // ],
        OrgId: [{ required: true, message: "请选择所属组织", trigger: "blur" }],
      },
      IsEdit: false,
      DeviceTypesArr: [],
      RegionData: [],
      imgList: [],
      fileList: [],
      delFileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      CompanyType: "景区",
      IsEditOrg: false,
    };
  },
  created: function () {
    this.Status = parseFloat(this.$route.query.status);
    switch (this.Status) {
      case 1:
        this.optionsLevel = this.optionsScenic;
        break;
      case 4:
        this.optionsLevel = this.optionsHotel;
        break;
      case 5:
        this.optionsLevel = this.optionsHotel;
        break;
      default:
        break;
    }
    this.CompanyType = this.$route.query.CompanyType;
    if (this.$route.query.InfoId) {
      this.search();
      this.getFileList();
    }
    if (this.$route.query.type == "look") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    if (this.$route.query.type == "add") {
      this.IsEditOrg = true;
    } else {
      this.IsEditOrg = false;
    }

    //区域
    this.getRegionInfo();
    this.basedatabind();
  },
  mounted: function () {},
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  methods: {
    //基础数据绑定 所属单位
    basedatabind() {
      this.loading = true;
      this.loadingText = "加载中...";
      utils
        .waitAll([this.config.getUValue("cyjc:cy", "")])
        .then((r) => {
          const eventlevelconf = r[0];
          this.typeOptions = eventlevelconf.JValue;
          const org = this.typeOptions.filter(
            (item) => item.ItemValue == this.Status
          );
          this.getOrgData(org);
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getOrgData(org) {
      utils
        .waitAll([
          () => {
            return new Apis.OrgApi().FindByConditions({
              ParentOrgId: org[0].ItemKey || "",
            });
          },
        ])
        .then((r) => {
          //获取组织下的用户信息
          this.optionsOrgId = r[0].data.Data || [];
        });
    },
    // 选择单位
    chooseOrg(v) {
      this.optionsOrgId.forEach((el) => {
        if (el.OrgId == v) {
          this.ruleForm.Name = el.OrgName;
        }
      });
    },
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new areaApi.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getCompanyData() {
      let searchInfo = {
        Name: this.ruleForm.Name,
        CompanyType: this.CompanyType,
      };
      return new MyApis.TbTourCompanyApi()
        .GetCompanyByCondition(searchInfo)
        .then((r) => {
          r = r.data.Data;

          if (r.length > 0) {
            this.$message({
              type: "warning",
              message: "该企业已存在",
            });
          } else {
            this.Add();
          }
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      let that = this;
      if (file.FileUrl) {
        // 最后提交的时候再删除
        this.delFileList.push(file);
        this.fileList.forEach((item) => {
          if (item.FileUrl == file.FileUrl) {
            item.Validity = 0;
          }
        });
      }
      let arr = [];
      fileList.forEach((item) => {
        if (that.$route.query.type == "edit") {
          if (!item.FileUrl) {
            arr.push(item.raw);
          }
        } else {
          arr.push(item.raw);
        }
      });
      this.imgList = arr;
    },
    uploadAvatar(item) {
      this.imgList.push(item.file);
    },
    // 选取经纬度
    onGotLngLat(obj) {
      this.ruleForm.Latitude = obj.lat || 0;
      this.ruleForm.Longitude = obj.lng || 0;
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 查询数据
    search() {
      let InfoId = this.$route.query.InfoId;
      let that = this;
      if (InfoId) {
        let searchInfo = { ID: InfoId };
        new MyApis.TbTourCompanyApi()
          .GetCompanyByCondition(searchInfo)
          .then((r) => {
            r = r.data.Data;
            console.log(r, "数据回显");
            that.ruleForm = r[0];
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //获取上传附件
    getFileList() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        const searchInfo = { AssocID: InfoId, PageSize: 100, PageIndex: 1 };
        this.data = this.$route.query.Info;
        this.loading = true;
        new Apis.FileApi()
          .GetFileList(searchInfo)
          .then((r) => {
            r = r.data.Data;
            this.fileList = r.FileList.map((item) => ({
              name: item.FileName,
              url: item.DownloadPath + "?d=1",
            }));
            console.log(this.fileList, "上传附件", r);
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //插入附件
    uploadAttch(feedid) {
      return new Promise((resolve, reject) => {
        let mediaList = this.imgList;
        var arr = [];
        mediaList.forEach((item) => {
          var option = {
            file: item,
            data: {
              module: "unifiedRelease", //模块名
              submodule: "Announcement", //子模块
              assocID: feedid, //业务ID
              uploader: ZJApp.ZJUser.current.UserName, //上传人
            },
            onProgress: () => {},
            onSuccess: () => {},
            onError: () => {},
          };
          arr.push(this.httpRequest(option));
        });

        waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    save() {
      let that = this;
      let uuid = ZJApp.ZJUtils.uuid();
      //先上传图片
      that.uploadAttch(uuid).then(() => {
        // 图片assocID作为提交的ID
        if (this.$route.query.type == "edit") {
          this.ruleForm.ID = this.$route.query.InfoId;
        } else {
          this.ruleForm.ID = uuid;
        }
        that.saveData();
      });
    },
    saveData() {
      this.ruleForm.JsonExtend = JSON.stringify(this.ruleForm.JsonExtend);
      this.ruleForm.CompanyType = this.CompanyType;

      // 图片的infoID和信息的infoID一样
      // let uuid = "";
      // if (this.$route.query.type == "edit") {
      //   uuid = this.$route.query.InfoId;
      // } else {
      //   uuid = ZJApp.ZJUtils.uuid();
      // }

      // let InfoAttachmentDTOList = [];
      // let deptId =
      //   ZJApp.ZJUser.current.Departments.length > 0
      //     ? ZJApp.ZJUser.current.Departments[0].OrgId
      //     : "error-no-department";

      // console.log("this.ruleForm")
      // console.log(this.ruleForm)

      //如果有图片
      // if (r && r.length > 0) {
      //   r.forEach((item) => {
      //     // this.ruleForm.ID = item.AssocID;
      //     let obj = {
      //       assoid: item.AssocID,
      //       Id: item.ID,
      //       Validity: 1,
      //       // "Extend1":"",
      //       // "Extend2":"",
      //       // "Extend3":"",
      //       OrgId: deptId,
      //       // "AttachmenetId": ZJApp.ZJUtils.uuid(),
      //       InfoId: uuid,
      //       FileName: item.FileName,
      //       FileUrl: item.DownloadPath,
      //       FileType: item.Extension,
      //       FileId: item.FileID,
      //       Creater: item.Creater,
      //       CreateTime: item.CreateTime,
      //       Modifier: item.Modifier,
      //       ModifyTime: item.ModifyTime,
      //     };
      //     InfoAttachmentDTOList.push(obj);
      //   });
      // }

      // console.log(InfoAttachmentDTOList, "图片");
      // if (this.$route.query.type == "edit") {
      //     let arr = [];
      //     this.ruleForm.InfoAttachmentDTOList = arr.concat(
      //       this.fileList,
      //       InfoAttachmentDTOList
      //     );
      //   } else {
      //     this.ruleForm.InfoAttachmentDTOList = InfoAttachmentDTOList;
      //   }
      // console.log(this.ruleForm, "提交表单");
      if (this.$route.query.type == "edit") {
        //编辑
        this.Edit();
      } else {
        // 增加
        this.getCompanyData();
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    //保存
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       this.loading = true;
    //       this.loadingText = "保存中...";
    //       if (this.$route.query.type == "add") {
    //         console.log(this.ruleForm);
    //         // this.Add();
    //       } else if (this.$route.query.type == "edit") {
    //         this.Edit();
    //       }
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    Add() {
      this.ruleForm.Validity = 1;
      this.ruleForm.CreateTime = new Date();
      this.ruleForm.Creater = ZJApp.ZJUser.current.UserName;
      this.ruleForm.ModifyTime = new Date();
      this.ruleForm.Modifier = ZJApp.ZJUser.current.UserName;
      // console.log(ZJApp.ZJUtils.uuid(), this.ruleForm, "提交表单121");
      new MyApis.TbTourCompanyApi()
        .AddItem(this.ruleForm)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.logInfo.ActionName = this.CompanyType + "基础信息添加";
          this.logInfo.LogMessage = r
            ? this.CompanyType + "基础信息添加成功"
            : this.CompanyType + "基础信息添加失败";
          this.logInfo.ModuleName = "产业基础信息";
          this.logInfo.PageName = this.CompanyType + "基础信息";
          this.addOperationLog();
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    Edit() {
      this.ruleForm.ModifyTime = new Date();
      this.ruleForm.Modifier = ZJApp.ZJUser.current.UserName;
      new MyApis.TbTourCompanyApi()
        .UpdateItem(this.ruleForm)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.logInfo.ActionName = this.CompanyType + "基础信息修改";
          this.logInfo.LogMessage = r
            ? this.CompanyType + "基础信息修改成功"
            : this.CompanyType + "基础信息修改失败";
          this.logInfo.ModuleName = "产业基础信息";
          this.logInfo.PageName = this.CompanyType + "基础信息";
          this.addOperationLog();
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
};
</script>
<style type="text/css"></style>
